// При переходе на новый маршрут прокручивает окно в начало страницы.
// Если в URL есть hash (например /#pricing), пропускаем, чтобы Home
// мог самостоятельно прокрутить к нужной секции.

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname, hash]);

  return null;
}
